import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateFnsConfigurationService, DateFnsModule } from 'ngx-date-fns';
import { ToastrModule } from 'ngx-toastr';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { AppRoutes } from '@app/app-routing.routes';
import { AlertService } from '@services/alert.service';
import { AuthenticationService } from '@services/authentication.service';
import { AttachmentDownloadService } from '@services/attachment-download.service';
import { BreakpointService } from '@services/breakpoint.service';
import { CommonService } from '@services/common.service';
import { ConfirmationService } from '@services/confirmation.service';
import { ImageService } from '@services/image.service';
import { DashboardService } from '@services/dashboard.service';
import { ContractService } from '@services/contract.service';
import { CompanyService } from '@services/company.service';
import { RelationService } from '@services/relation.service';
import { LanguageService } from '@services/language.service';
import { LoadingService } from '@services/loading.service';
import { TranslationService } from '@services/translation.service';
import { TokenService } from '@services/token.service';
import { EditableService } from '@services/editable.service';
import { UserService } from '@services/user.service';
import { ValidationService } from '@services/validation.service';
import { ReportService } from '@services/report.service';
import { OutSmartService } from '@services/out-smart.service';
import { MailHistoryService } from '@services/mail-history.service';
import { RentCalculationService } from '@services/rent-calculation.service';
import { TargetManagementService } from '@services/target-management.service';
import { GlobalSettingsService } from '@services/global-settings.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorService } from '@services/interceptor.service';
import { AuthGuard } from '@guards/auth.guard';
import { UnAuthGuard } from '@guards/un-auth.guard';
import { nl } from 'date-fns/locale';
import { registerLocaleData } from '@angular/common';
import localeNL from '@angular/common/locales/nl';
import { LoadingScreenComponent } from '@shared/components/loading-screen/loading-screen.component';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { ModemService } from '@services/modem.service';


const dateFnsConfig = new DateFnsConfigurationService();
dateFnsConfig.setLocale(nl);

registerLocaleData(localeNL, 'nl-NL');

export const getUTCOffsetDate = (date = new Date()): Date => {
	return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
};

export const appConfig: ApplicationConfig = {
	providers: [
		importProvidersFrom(
			BrowserModule,
			BrowserAnimationsModule,
			DateFnsModule.forRoot(),
			ToastrModule.forRoot({
				maxOpened: 1,
				preventDuplicates: true,
				positionClass: 'toast-bottom-full-width',
				progressBar: true,
			}),
		),
		
		provideRouter(
			AppRoutes,
			withPreloading(PreloadAllModules),
			withRouterConfig({
				paramsInheritanceStrategy: 'always',
			}),
		),
		
		AlertService,
		AuthenticationService,
		AttachmentDownloadService,
		BreakpointService,
		CommonService,
		ConfirmationService,
		ImageService,
		DashboardService,
		ContractService,
		CompanyService,
		RelationService,
		LanguageService,
		LoadingService,
		TranslationService,
		TokenService,
		EditableService,
		UserService,
		ValidationService,
		ReportService,
		OutSmartService,
		MailHistoryService,
		RentCalculationService,
		TargetManagementService,
		GlobalSettingsService,
		ModemService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorService,
			multi: true,
		},
		AuthGuard,
		UnAuthGuard,
		{ provide: DateFnsConfigurationService, useValue: dateFnsConfig },
		{ provide: LOCALE_ID, useValue: 'nl-NL' },
		provideHttpClient(withInterceptorsFromDi()),
	]
}